import { render } from "./MyContracts.vue?vue&type=template&id=0fec7652&scoped=true"
import script from "./MyContracts.vue?vue&type=script&lang=js"
export * from "./MyContracts.vue?vue&type=script&lang=js"

import "./MyContracts.vue?vue&type=style&index=0&id=0fec7652&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fec7652"]])

export default __exports__